import React from "react";
import { useState, useEffect } from 'react';
import axiosInstance from '../../helpers/axios';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useSelector } from "react-redux";
 const InstitutePar=()=>{
  const user = null;
   const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
  const [monthlyPar, setMonthlyPar] = useState({ parCount: [], parAmount: [] });
  const [isLoading, setIsLoading] = useState(false); 
  const [isLoadingCount, setIsLoadingCount] = useState(false); 
  const [isLoadingAmount, setIsLoadingAmount] = useState(false); 
  useEffect(() => {
    setIsLoading(true)
    let queryParams = {};
    if (productTypeSelected && productTypeSelected !== "all") {
      queryParams.loanType = Number(productTypeSelected);
    }
    axiosInstance.get('/analytics/par-reports', {
      params: queryParams,
      headers: {
      }
    })
      .then(function (res) {
        setMonthlyPar(res?.data?.data);
        const loadingTimeout = setTimeout(() => {
          setIsLoading(false);
        }, 300);
        
      })
      .catch(function (error) {
      });

  }, [productTypeSelected]);
 
  function formatNumberWithCommas(number) {
    const n = number === undefined || number === null ? 0 : Number(number);
    if (isNaN(n)) return number;
    const isNegative = n < 0;
    const abs = Math.abs(n);
    const parts = String(abs).split('.');
    let intPart = parts[0];
    const decPart = parts[1] ? '.' + parts[1] : '';
    if (intPart.length > 3) {
      const last3 = intPart.slice(-3);
      let rest = intPart.slice(0, -3);
      rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',');
      intPart = rest + ',' + last3;
    }
    return (isNegative ? '-' : '') + intPart + decPart;
  }

  function truncateText(text, maxLength = 28) {
    if (!text) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + '....' : text;
  }

  const renderInstituteDetailsTable = (rows = [], isAmountView = false) => {
    const columns = [
      { key: 'institute_name', label: 'Institute', align: 'left', width: '22%' },
      { key: 's1_1_to_30_days', label: 'S1(1-30)' },
      { key: 's2_31_to_60_days', label: 'S2(31-60)' },
      { key: 's3_61_to_90_days', label: 'S3(61-90)' },
      { key: 'm1_91_to_120_days', label: 'M1(91-120)' },
      { key: 'm2_121_to_180_days', label: 'M2(121-180)' },
      { key: 'X_Above_181', label: 'X(Above-181)' },
      { key: 'total', label: 'Total' },
    ];

    const getRowTotal = (row) => {
    if (row.total !== undefined && row.total !== null) {
      return Number(row.total) || 0;
    }
    return [
      's1_1_to_30_days',
      's2_31_to_60_days',
      's3_61_to_90_days',
      'm1_91_to_120_days',
      'm2_121_to_180_days',
      'X_Above_181',
    ].reduce((sum, key) => sum + (Number(row[key]) || 0), 0);
  };

  const sortedRows = [...rows].sort((a, b) => getRowTotal(b) - getRowTotal(a));
    const formatValue = (key, value) => {
      if (key === 'institute_name') return value || '-';
      const safeValue = Number(value) || 0;
      return isAmountView ? `₹${formatNumberWithCommas(safeValue)}` : formatNumberWithCommas(safeValue);
    };

    return (
      <div
        style={{
          margin: '10px 24px 20px 24px',
          border: '1px solid #e5e7eb',
          borderRadius: '10px',
          background: '#fff',
          boxShadow: '0 8px 20px rgba(16,24,40,0.08)',
          overflow: 'hidden',
        }}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead style={{ background: '#f8fafc' }}>
            <tr>
              {columns.map((column) => (
                <th
                  key={column.key}
                  style={{
                    padding: '12px 16px',
                    textAlign: column.align || 'center',
                    fontSize: '0.85vw',
                    fontFamily: 'Inter-Medium',
                    color: '#475467',
                    borderBottom: '1px solid #e4e7ec',
                    width: column.width || 'auto',
                  }}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedRows?.length ? (
              sortedRows.map((row, idx) => (
                <tr
                  key={`${row.institute_name || 'row'}-${idx}`}
                  style={{
                    borderBottom: idx === sortedRows.length - 1 ? 'none' : '1px solid #f1f5f9',
                    lineHeight: '1.3rem',
                  }}
                >
                  {columns.map((column) => (
                    <td
                      key={column.key}
                      style={{
                        padding: '10px 16px',
                        textAlign: column.align || 'center',
                        fontSize: '0.85vw',
                        color: '#475467',
                        fontFamily: 'Inter',
                        whiteSpace: column.key === 'institute_name' ? 'nowrap' : 'normal',
                        textOverflow: column.key === 'institute_name' ? 'ellipsis' : 'initial',
                        overflow: column.key === 'institute_name' ? 'hidden' : 'visible',
                      }}
                      title={column.key === 'institute_name' && !isAmountView ? `${row?.institute_name || ''}${(row?.loan_details_count !== undefined || row?.principal_amount !== undefined) ? ' (' + (row?.loan_details_count ?? '-') + ' | ' + (row?.principal_amount !== undefined ? formatNumberWithCommas(row.principal_amount) : '-') + ' |)' : ''}` : undefined}
                    >
                      {column.key === 'total'
                      ? formatValue(column.key, getRowTotal(row))
                      : column.key === 'institute_name' && !isAmountView ? (
                        <div style={{display: 'flex', alignItems: 'center',marginLeft:'10px'}}>
                          <span style={{flex: '1 1 auto', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block',color: '#475467',fontWeight:'bold'}}>
                            {truncateText(row?.institute_name) || '-'}
                          </span>
                          <span style={{marginLeft: '8px', flex: '0 0 160px', whiteSpace: 'nowrap', color: '#475467',fontWeight:'bold'}}>
                            {(row?.loan_details_count !== undefined || row?.principal_amount !== undefined) ? `(${row?.loan_details_count ?? '-'} | ${row?.principal_amount !== undefined ? formatNumberWithCommas(row.principal_amount) : '-'})` : ''}
                          </span>
                        </div>
                      ) : formatValue(column.key, row[column.key])}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  style={{
                    padding: '20px',
                    textAlign: 'center',
                    color: '#98a2b3',
                    fontSize: '0.85vw',
                  }}
                >
                  No institute level data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    );
  };


  const [isOpenCount, setIsOpenCount] = useState(false);
  const [instParCount,setInstParCount] = useState([]);
  const [instParAmount,setInstParAmount] = useState([]);
  const [openCountRowDate, setOpenCountRowDate] = useState(null);
  const [openAmountRowDate, setOpenAmountRowDate] = useState(null);

  const openCountRow = (item,tableType) => {
  const currentOpenDate = tableType === 'count' ? openCountRowDate : openAmountRowDate;
  const setOpenDate = tableType === 'count' ? setOpenCountRowDate : setOpenAmountRowDate;  
  const isCurrentlyOpen = currentOpenDate === item?.month_start_date;
  if (isCurrentlyOpen) {
    setOpenDate(null);
  } else {
    setOpenDate(item?.month_start_date);
    setIsOpenCount(!isOpenCount)
    setIsLoadingCount(true)
    let url = `/analytics/institute-par-reports?date=${item?.month_start_date}`
    if (productTypeSelected && productTypeSelected !== "all") {
      url += `&loanType=${Number(productTypeSelected)}`
    }
    axiosInstance.get(url)
      .then(function (res) {
        setInstParCount(res?.data?.data?.count);
        setInstParAmount(res?.data?.data?.amount);
        setIsLoadingCount(false)
      })
      .catch(function (error) {
        setIsLoadingCount(false)
      });
  }
};
  return (
    <div style={{width:"100%",backgroundColor:'white',minHeight:'100vh'}}>
    <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>Inst. wise Par Count</p>
  {isLoading ? (
                  <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                  <CircularProgress />
                </Box>
                ): (
                  <>
                <div className='tables' style={{ marginTop: '20px' }}> 
                <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
                  <thead className='table-heading'>
                    <tr>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'left', padding: '8px 10px' }}>Month</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>S1(1-30)</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>S2(31-60)</th>
                      <th style={{ fontSize: '14px', width:'11%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>S3(61-90)</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>M1(91-120)</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>M2(121-180)</th>
                      <th style={{ fontSize: '14px', width:'11%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>X(Above-181)</th>
                      <th style={{ fontSize: '14px', width:'11%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>Total<span style={{marginRight:'55px'}}/></th>
                    </tr>
                  </thead>
                  <tbody className='table-body'>
                    {monthlyPar?.parLoanCount?.slice(0,12)?.map((item, index) => {
                      const isThisRowOpen = openCountRowDate  === item?.month_start_date;
                      return(
                        <React.Fragment key={index}>
                          <tr className="table-row" style={{lineHeight:'1.3rem', cursor: 'pointer',background:isThisRowOpen?"#f2f2f2":""}} onClick={() => openCountRow(item,'count')}>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px' }}>
                              {item.month_start_date ? item.month_start_date : '-'}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item.s1_1_to_30_days ? item.s1_1_to_30_days : "0"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item.s2_31_to_60_days ? item.s2_31_to_60_days : "0"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item.s3_61_to_90_days ? item.s3_61_to_90_days : "0"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item.m1_91_to_120_days ? item.m1_91_to_120_days : "0"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item.m2_121_to_180_days ? item.m2_121_to_180_days : '0'}
                            </td>
                             <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item.X_Above_181 ? item.X_Above_181 : '0'} 
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
                              <span style={{marginLeft:'25px'}}>
                                {
                                  (item.s1_1_to_30_days ? item.s1_1_to_30_days : 0) +
                                  (item.s2_31_to_60_days ? item.s2_31_to_60_days : 0) +
                                  (item.s3_61_to_90_days ? item.s3_61_to_90_days : 0) +
                                  (item.m1_91_to_120_days ? item.m1_91_to_120_days : 0) +
                                  (item.m2_121_to_180_days ? item.m2_121_to_180_days : 0) +
                                  (item.X_Above_181 ? item.X_Above_181 : 0)
                                }
                              </span>
                              <span>
                                {isThisRowOpen ? <ChevronUp size={16} style={{marginLeft:'50px'}}/> : <ChevronDown size={16} style={{marginLeft:'50px'}}/>}
                              </span>
                            </div>
                            </td>
                          </tr>
                          {isLoadingCount && isThisRowOpen ? (
                            <tr>
                            <td colSpan="8" style={{ padding: '0' }}>
                            <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                              <CircularProgress />
                            </Box>
                            </td>
                            </tr>
                            
                          ):(
                            <>
                          {isThisRowOpen && (
                            <tr>
                              <td colSpan="8" style={{ padding: '0',borderBottom:"#f2f2f2" }}>
                                {renderInstituteDetailsTable(instParCount, false)}
                              </td>
                            </tr>
                          )}
                            </>
                          )}
                          
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              </div>
                  <p style={{textAlign:"center",fontFamily:'Inter-Medium',color:'#667085',fontSize:'25px'}}>Inst. wise Par Amount</p>
             
              <div className='tables' style={{ marginTop: '20px' }}> 
                <table style={{ width: '100%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
                  <thead className='table-heading'>
                    <tr>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'left', padding: '8px 10px' }}>Month</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>S1(1-30)</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>S2(31-60)</th>
                      <th style={{ fontSize: '14px', width:'11%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>S3(61-90)</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>M1(91-120)</th>
                      <th style={{ fontSize: '14px', width:'10%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>M2(121-180)</th>
                      <th style={{ fontSize: '14px', width:'11%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>X(Above-181)</th>
                      <th style={{ fontSize: '14px', width:'11%', fontFamily:"Inter", textAlign: 'center', padding: '8px 10px' }}>Total<span style={{marginRight:'55px'}}/></th>
                    </tr>
                  </thead>
                  <tbody className='table-body'>
                    {monthlyPar?.parAmount?.slice(0,12)?.map((item, index) => {
                      const isThisRowOpen = openAmountRowDate  === item?.month_start_date;
                      return(
                        <React.Fragment key={index}>
                          <tr className="table-row" style={{lineHeight:'1.3rem', cursor: 'pointer',background:isThisRowOpen?"#f2f2f2":""}} onClick={() => openCountRow(item,'amount')}>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px' }}>
                              {item.month_start_date ? item.month_start_date : '-'}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item?.s1_1_to_30_days ? (<>₹{formatNumberWithCommas(item.s1_1_to_30_days)}</>) : "-"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                             {item?.s2_31_to_60_days ? (<>₹{formatNumberWithCommas(item.s2_31_to_60_days)}</>) : "-"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item?.s3_61_to_90_days ? (<>₹{formatNumberWithCommas(item.s3_61_to_90_days)}</>) : "-"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                              {item?.m1_91_to_120_days ? (<>₹{formatNumberWithCommas(item.m1_91_to_120_days)}</>) : "-"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                             {item?.m2_121_to_180_days ? (<>₹{formatNumberWithCommas(item.m2_121_to_180_days)}</>) : "-"}
                            </td>
                             <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                               {item?.X_Above_181 ? (<>₹{formatNumberWithCommas(item.X_Above_181)}</>) : "-"}
                            </td>
                            <td style={{ fontSize: '14px', fontFamily: "Inter", color: '#667085', padding: '8px 10px', textAlign: 'center' }}>
                             <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '15px' }}>
                              <span >
                                 ₹{formatNumberWithCommas(
                                    Math.round(item.s1_1_to_30_days || 0) +
                                    Math.round(item.s2_31_to_60_days || 0) +
                                    Math.round(item.s3_61_to_90_days || 0) +
                                    Math.round (item.m1_91_to_120_days || 0) +
                                    Math.round (item.m2_121_to_180_days || 0) +
                                    Math.round(item.X_Above_181 || 0)
                                  )}
                              </span>
                              <span>
                                {isThisRowOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                              </span>
                            </div>
                            </td>
                          </tr>
                          {isLoadingCount && isThisRowOpen ? (
                            <tr>
                            <td colSpan="8" style={{ padding: '0' }}>
                            <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                              <CircularProgress />
                            </Box>
                            </td>
                            </tr>
                            
                          ):(
                            <>
                            {isThisRowOpen && (
                            <tr>
                              <td colSpan="8" style={{ padding: '0',borderBottom:"#f2f2f2" }}>
                                {renderInstituteDetailsTable(instParAmount, true)}
                              </td>
                            </tr>
                          )}
                            </>
                          )}
                          
                        </React.Fragment>
                      )
                    })}
                  </tbody>
                </table>
              </div>
                  </>
                )}



    </div>
  )
}

export default InstitutePar
